import { Client } from '../../../api/dealer-api-interface-client';

export const getClientTitle = (c: any) => {
  const client = c as Client;
  return `${client.name}`;
};
